import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../authentication/service/auth.service';
import { Router } from '@angular/router';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { SellerApiService } from '../service/seller-api.service';
import { ProfileUser } from '../../authentication/user';

@Component({
  selector: 'app-homedashboard',
  templateUrl: './homedashboard.component.html',
  styleUrls: ['./homedashboard.component.scss']
})
export class HomedashboardComponent implements OnInit {

  user: ProfileUser = new ProfileUser();
  constructor(private router: Router, public auth: AuthService,
    private cognitoService: CognitoUtil, private sellerService: SellerApiService ) { }

  ngOnInit() {
      // tslint:disable-next-line:prefer-const
      let userDetails = this.cognitoService.getCurrentUser();
      if (userDetails != null) {
        // get User Details By username
        this.sellerService.getProfileDetails(userDetails.username).subscribe(res => {
          if (res != null) {
            this.user = res;
            localStorage.removeItem('yasoUserFirstName');
            localStorage.setItem('yasoUserFirstName', this.user.first_name);
          }
        }, err => {
          console.log(err);
        });
      }

  }
  private checkAuthentication() {
    Observable.fromPromise(this.auth.isAuthenticated())
      .map(isAuthed => {
        return isAuthed;
      });
  }

  callCommonFunction(url): void {
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/homedashboard/homedashboard.component.ts